import React, { useState } from "react";

import VisibilitySensor from "react-visibility-sensor";
import { useTranslation } from "react-i18next";

function CareerThree() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={400}>
      <div className={`careerThree ${isVisible ? "visible" : ""}`}>
        <h1 className={`${isVisible ? "visible" : ""}`}>
          {t("career_three_title")}
        </h1>
        <p className={`${isVisible ? "visible" : ""}`}>
          {t("career_three_text")}
        </p>
        <a
          className={`${isVisible ? "visible" : ""}`}
          href="https://ghlogistica.vagas.solides.com.br/"
          target="_blank"
          rel="noreferrer"
        >
          <button>{t("career_three_btn")}</button>
        </a>
      </div>
    </VisibilitySensor>
  );
}
export default CareerThree;
